import { useState, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import UpdateButton from "../../atoms/Button/UpdateButton";
import {
  CustomContainer,
  StyledDataGrid,
  customDataGridLocaleTextAll,
  customDataGridLocaleTextLoading,
  customDataGridLocaleTextNoData,
} from "../../../styles/styles";
import IconButtonWithTooltip from "../../atoms/Button/IconButtonWithTooltip";
import EditIcon from "@mui/icons-material/Edit";

interface Owner {
  autoOwnerId: number;
  ownerId: string;
  subscribeNumber: string;
  departmentName: string;
  ownerPhone: string;
  ownerEmail: string;
  ownerName: string;
  representativeName: string;
  picName: string;
  memo: string;
  isEnabled: boolean;
}

const OwnerListPage = () => {
  const navigate = useNavigate();

  const [data, setData] = useState<Owner[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      // JWTトークンを取得します
      const jwtToken = await getJwtTokenFromIdToken();
      try {
        // call indexOwners API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT + "/owners",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: jwtToken,
            },
          }
        );
        const jsonData = await response.json();
        console.log(
          "LAD契約者（オーナー）取得APIレスポンス" + JSON.stringify(jsonData)
        );
        setData(jsonData.owners || []);
        setIsLoading(false);
      } catch (error: any) {
        setError(error);
        setIsLoading(false);
        setData([]);
      }
    };

    fetchData();
  }, []);

  const handleEditOwnerClick = (autoOwnerId: number) => {
    navigate(`/owners/` + autoOwnerId);
    console.log(
      `LAD契約者（オーナー）編集 button clicked 選択されたLAD契約者（オーナー）: ${autoOwnerId}`
    );
  };

  const handleNewOwnerClick = () => {
    navigate(`/owners/new`);
    console.log(`LAD契約者（オーナー）新規登録 button clicked`);
  };

  if (isLoading) {
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress /> {/* MUIの CircularProgress コンポーネント */}
    </Box>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const columns: GridColDef[] = [
    {
      field: "ownerId",
      headerName: "LAD契約者（オーナー）ID",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "subscribeNumber",
      headerName: "契約者番号",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "ownerName",
      headerName: "名称(氏名)",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "departmentName",
      headerName: "会社名(部署名)",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "representativeName",
      headerName: "代表者名",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "picName",
      headerName: "担当者名",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "ownerPhone",
      headerName: "電話番号",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "ownerEmail",
      headerName: "メール",
      flex: 2,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "memo",
      headerName: "メモ",
      flex: 3,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "autoOwnerId",
      headerName: "操作",
      flex: 1,
      renderCell: (params: any) => (
        <IconButtonWithTooltip
          title="編集"
          onClick={() => handleEditOwnerClick(params.row.autoOwnerId)}
          icon={<EditIcon />}
        />
      ),
    },
  ];

  return (
    <CustomContainer maxWidth={false}>
      <Box display="flex" flexDirection="column" marginBottom={2}>
        <Typography variant="h5" component="h2" gutterBottom>
          LAD契約者（オーナー）一覧
        </Typography>
        <Box display="flex" justifyContent="flex-end">
          <Box marginLeft="auto">
            <Button
              variant="outlined"
              color="primary"
              onClick={handleNewOwnerClick}
              sx={{ marginRight: 1 }}
            >
              LAD契約者（オーナー）新規登録
            </Button>
          </Box>
          <Box marginLeft={1}>
            {" "}
            <UpdateButton />
          </Box>
        </Box>
      </Box>
      <div style={{ height: 700, width: "100%" }}>
        <StyledDataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row.autoOwnerId}
          disableRowSelectionOnClick
          localeText={
            isLoading
              ? customDataGridLocaleTextLoading
              : data.length === 0
              ? customDataGridLocaleTextNoData
              : customDataGridLocaleTextAll
          }
        />
      </div>
    </CustomContainer>
  );
};

export default OwnerListPage;
